import { flow, forEach, get, head, isEmpty, map } from 'lodash';
import { Button, Col, Row } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import { Field, FieldArray, formValueSelector, reduxForm } from 'redux-form';
import { Travellers } from '../Travellers';
import { RecalculateButton } from '../RecalculateButton';
import FieldFormControl from '../../../../../components/FieldFormControl';
import {
  allowOnlyApostrophes,
  hasEmojis, hasSpecialCharacters,
  isAdult,
  isEmail,
  isPhone,
  isRequired,
  validateDays,
  validateMonths
} from '../../../../../util/validators';
import { TITLES } from '../../../../../helpers/Quote';
import { ITraveller } from '../../../../../data/api/models';
import { ErrorDisplay } from '../../../../../components/FieldFormControl/ErrorDisplay';
import QuoteIcons from '../Icon/QuoteIcons';
import { renderNewLines } from '../../../../../helpers/text-helper';
import { connect } from 'react-redux';
import { IStore } from '../../../../../redux/IStore';
import React = require('react');

const GroupTypeSelection = ({
                              product,
                              tripType,
                              i18n,
                              groupType,
                              change,
                              renderDefinition,
                              travellers,
                              synchronousError,
                              quoteState,
                              valid,
                              hideRecalculateButton = false,
                              allowLeadEdit = false,
                              forceShowRecalculate = false,
                              recalculate = null,
                              ...props
                            }) => {

  const [showFamilySelect, setShowFamilySelect] = useState(false);
  const [showGroupSelect, setShowGroupSelect] = useState(false);
  const [selectedAdultNumber, setSelectedAdultNumber] = useState({ value: 2, label: 2 });
  const [selectedChildrenNumber, setSelectedChildrenNumber] = useState({ value: 1, label: 1 });
  const [selectedGroupAdultNumber, setSelectedGroupAdultNumber] = useState({ value: 2, label: 2 });
  const [selectedGroupChildrenNumber, setSelectedGroupChildrenNumber] = useState({ value: 0, label: 0 });
  const [savedFamilySelection, setSavedFamilySelection] = useState(false);
  const [savedGroupSelection, setSavedGroupSelection] = useState(false);
  const [showRecalculateButton, setShowRecalculateButton] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [groupSelectionError, setGroupSelectionError] = useState('');
  const maxTravellersOnGroups = 10;
  const minTravellersOnGroups = 2;

  useEffect(() => {
    if (groupType === 'family' || groupType === 'family_one_adult' || groupType === 'group') {
      let adults = 0;
      let children = 0;
      forEach(travellers, (traveller, index) => {
        if (traveller.type === 'adult') {
          adults++;
        }

        if (traveller.type === 'child') {
          children++;
        }
      })
      setSelectedChildrenNumber({ value: children ? children : 1, label: children ? children : 1 })
      setSelectedGroupChildrenNumber({ value: children ? children : 1, label: children ? children : 1 })
      setSelectedAdultNumber({ value: adults, label: adults })
      setSelectedGroupAdultNumber({ value: adults, label: adults })
    }

  }, []);

  if (travellers && travellers.length > 0) {
    useEffect(() => {
      if (get(travellers, `[${0}].dobSeparate`, null)) {
        const separate = get(travellers, `[${0}].dobSeparate`);
        const base = 'travellers[0]';
        change(`${base}.dob`, (separate.day + '/' + separate.month + '/' + separate.year));
      }
    }, [travellers[0]]);
  }

  useEffect(() => {
    if (groupType === 'family' || groupType === 'family_one_adult') {
      setShowFamilySelect(true)
      setShowGroupSelect(false)
      setSavedGroupSelection(false)
    } else if (groupType === 'group') {
      setShowGroupSelect(true)
      setShowFamilySelect(false)
      setSavedFamilySelection(false)
    } else {
      setShowGroupSelect(false)
      setShowFamilySelect(false)
      setSavedFamilySelection(false)
      setSavedGroupSelection(false)
    }
  }, [groupType]);

  const onChangeAdults = (selection) => {
    if (selection.value === 1 && groupType === 'family') {
      change('groupType', 'family_one_adult')
    }
    if (selection.value === 2 && groupType === 'family_one_adult') {
      change('groupType', 'family')
    }

    setSelectedAdultNumber(selection)
  }

  const onChangeGroupAdults = (selection) => {
    setSelectedGroupAdultNumber(selection)
  }

  const onChangeGroupChildren = (selection) => {
    setSelectedGroupChildrenNumber(selection)
  }

  const onChangeChildren = (selection) => {
    setSelectedChildrenNumber(selection)
  }

  const renderAdultDropdown = () => {
    const options = [
      { value: 1, label: 1 },
      { value: 2, label: 2 },
    ]

    return (
      <Select
        value={selectedAdultNumber}
        className={''}
        onChange={onChangeAdults}
        clearable={false}
        options={options}
      />
    )
  }

  const renderAdultGroupDropdown = () => {
    const options = [
      { value: 1, label: 1 },
      { value: 2, label: 2 },
      { value: 3, label: 3 },
      { value: 4, label: 4 },
      { value: 5, label: 5 },
      { value: 6, label: 6 },
      { value: 7, label: 7 },
      { value: 8, label: 8 },
      { value: 9, label: 9 },
      { value: 10, label: 10 },
    ]

    return (
      <Select
        value={selectedGroupAdultNumber}
        className={''}
        onChange={onChangeGroupAdults}
        clearable={false}
        options={options}
      />
    )
  }

  const renderChildrenGroupDropdown = () => {
    const options = [
      { value: 0, label: 0 },
      { value: 1, label: 1 },
      { value: 2, label: 2 },
      { value: 3, label: 3 },
      { value: 4, label: 4 },
      { value: 5, label: 5 },
      { value: 6, label: 6 },
      { value: 7, label: 7 },
      { value: 8, label: 8 },
      { value: 9, label: 9 },
    ]

    return (
      <Select
        value={selectedGroupChildrenNumber}
        className={''}
        onChange={onChangeGroupChildren}
        clearable={false}
        options={options}
      />
    )
  }

  const renderChildrenDropdown = () => {
    const options = [
      { value: 1, label: 1 },
      { value: 2, label: 2 },
      { value: 3, label: 3 },
      { value: 4, label: 4 },
      { value: 5, label: 5 },
    ]

    return (
      <Select
        value={selectedChildrenNumber}
        className={''}
        onChange={onChangeChildren}
        clearable={false}
        options={options}
      />
    )
  }

  const handleGoBack = () => {
    setSavedFamilySelection(false);
  }

  const handleGroupGoBack = () => {
    setSavedGroupSelection(false);
  }

  const handleSaveFamilySelection = () => {
    setSavedFamilySelection(true);
  }

  const handleSaveGroupSelection = () => {
    const selectedGroupTravellers = selectedGroupAdultNumber.value + selectedGroupChildrenNumber.value;
    const shouldAllowSave = selectedGroupTravellers <= maxTravellersOnGroups;
    const isMinimumTravellerNumber = selectedGroupTravellers >= 2;

    if (shouldAllowSave && isMinimumTravellerNumber) {
      setSavedGroupSelection(true)
      setGroupSelectionError('')
    } else if (!shouldAllowSave) {
      setGroupSelectionError(`Max number of travellers can\'t exceed ${maxTravellersOnGroups} current selection is ${selectedGroupTravellers}!`)
    } else if (!isMinimumTravellerNumber) {
      setGroupSelectionError(`Min number of travellers must be  ${minTravellersOnGroups} current selection is ${selectedGroupTravellers}!`)
    }
  }

  const handleRecalculate = () => {
    if (recalculate) {
      recalculate();
    }
  }

  const renderGroupTypes = (name, key) => {
    if (key === 'family_one_adult') {
      return;
    }

    if (key === 'individual') {
      name = 'Single traveller'
    }

    const selected = groupType === key || (key === 'family' && groupType === 'family_one_adult');

    const onGroupTypeChange = () => {
      change('groupType', key);
      setShowRecalculateButton(true);
    }

    const getImage = () => {
      switch (key) {
        case 'individual':
          return QuoteIcons({ name: 'Person', color: 'darkBlue' });
        case 'couple':
          return QuoteIcons({ name: 'Couple', color: 'darkBlue' });
        case 'family':
          return QuoteIcons({ name: 'Family', color: 'darkBlue' });
        case 'group':
          return QuoteIcons({ name: 'Group', color: 'darkBlue' });
        default:
          return (<></>);
      }
    }

    return (
      <div
        key={key}
        className={selected ? 'group-type-selection-container selected' : 'group-type-selection-container'}
        onClick={onGroupTypeChange}
      >
        <div>{getImage()}</div>
        <div className={'group-type-description-container'}>
          <span className={'group-type-name'}>{name}</span>
          <div className={'group-type-subtext'}>
            {renderNewLines(i18n.quote.tripDetails.groupTypeDescriptions[key])}
          </div>
        </div>
      </div>
    );
  }

  const renderRecalculateButton = () => {
    // const isLeadError = leadTravellerDobError() !== null;
    return (
      <RecalculateButton
        text={'CONTINUE'}
        handleRecalculate={handleRecalculate} disable={disableButton} valid={valid}
        block={true}
        isCalculating={quoteState.isCalculating}
      />
    )
  }

  const leadTravellerDobError = (): string => {
    const leadTraveller: ITraveller = head(travellers);
    const day = get(leadTraveller, 'dobSeparate.day', null);
    const month = get(leadTraveller, 'dobSeparate.month', null);
    const year = get(leadTraveller, 'dobSeparate.year', null);

    if (day && month && year) {
      return isAdult(`${day}/${month}/${year}`)
    }
    return null
  }

  const renderLeadTravellerDetails = () => {
    const leadTraveller: ITraveller = head(travellers);
    const leadDobError = leadTravellerDobError();
    return (
      <>
        {allowLeadEdit && (
          <>
            <div>
              <div>
                <h3>{'Adult 1'}</h3>
              </div>
              <Row>
                <Col xs={6} className={'full-width-xs'}>Your preferred title</Col>
                <Col xs={6} className={'full-width-xs title-selection-container'}>
                  {map(TITLES, (value, key) => {
                    const isSelected = leadTraveller.title === value;
                    return (
                      <Col xs={4}
                           className={isSelected ? 'traveller-title-selection selected' : 'traveller-title-selection'}
                           key={key}>
                        <div>
                          <Field
                            name={`travellers[${0}].title`}
                            id={key + '-btn'}
                            type="radio"
                            value={value}
                            component={FieldFormControl}
                            validate={[isRequired]}
                          >
                            <div className={`trip-type-btn ${key}`}>
                              <div className={'trip-type-selection-container'}>
                                {value}
                              </div>
                            </div>
                          </Field>
                        </div>
                      </Col>
                    )
                  })}
                </Col>
              </Row>
              <Row className={'adm-form-group'}>
                <Col xs={6} className={'full-width-xs'}>First Name</Col>
                <Col xs={6} className={'full-width-xs'}>
                  <Field
                    name={`travellers[${0}].firstName`}
                    type="text"
                    component={FieldFormControl}
                    validate={[isRequired, hasEmojis, hasSpecialCharacters]}
                    autocomplete="new-password"
                  />
                </Col>
              </Row>
              <Row className={'adm-form-group'}>
                <Col xs={6} className={'full-width-xs'}>Last Name</Col>
                <Col xs={6} className={'full-width-xs'}>
                  <Field
                    name={`travellers[${0}].lastName`}
                    type="text"
                    component={FieldFormControl}
                    validate={[isRequired, hasEmojis, allowOnlyApostrophes]}
                    autocomplete="new-password"
                  />
                </Col>
              </Row>
              <Row className={'adm-form-group'}>
                <Col xs={6} className={'full-width-xs'}>Date of Birth</Col>
                <Col xs={2} className={'full-width-xs'}>
                  <Field
                    name={`travellers[${0}].dobSeparate.day`}
                    inputmode="numeric"
                    type="text"
                    maxLength={'2'}
                    placeholder={'DD'}
                    className={'text-center'}
                    component={FieldFormControl}
                    validate={[isRequired, hasEmojis, validateDays]}
                    autocomplete="new-password"
                  />
                  <div className={'text-center'}>Day</div>
                </Col>
                <Col xs={2} className={'full-width-xs'}>
                  <Field
                    name={`travellers[${0}].dobSeparate.month`}
                    inputmode="numeric"
                    type="text"
                    maxLength={'2'}
                    placeholder={'MM'}
                    className={'text-center'}
                    component={FieldFormControl}
                    validate={[isRequired, hasEmojis, validateMonths]}
                    autocomplete="new-password"
                  />
                  <div className={'text-center'}>Month</div>
                </Col>
                <Col xs={2} className={'full-width-xs'}>
                  <Field
                    name={`travellers[${0}].dobSeparate.year`}
                    inputmode="numeric"
                    type="text"
                    maxLength={'4'}
                    placeholder={'YYYY'}
                    className={'text-center'}
                    component={FieldFormControl}
                    validate={[isRequired, hasEmojis]}
                    autocomplete="new-password"
                  />
                  <div className={'text-center'}>Year</div>
                </Col>
                <Col xs={6}/>
                <Col xs={6} className={'full-width-xs'}>
                  <ErrorDisplay error={leadDobError}/>
                </Col>
              </Row>
            </div>
            <Row className={'adm-form-group'}>
              <Col xs={6} className={'full-width-xs'}>Email address</Col>
              <Col xs={6} className={'full-width-xs'}>
                <Field
                  name={`travellers[${0}].email`}
                  type="email"
                  component={FieldFormControl}
                  validate={[isRequired, isEmail]}
                  autocomplete="new-password"
                />
              </Col>
            </Row>
            <Row className={'adm-form-group'}>
              <Col xs={6} className={'full-width-xs'}>Phone number</Col>
              <Col xs={6} className={'full-width-xs'}>
                <Field
                  name={`travellers[${0}].phone`}
                  inputmode="numeric"
                  type="text"
                  component={FieldFormControl}
                  validate={[isRequired, isPhone]}
                  autocomplete="new-password"
                />
              </Col>
            </Row>
          </>
        )}
      </>
    )
  }

  const handleDisableButtons = (value) => {
    setDisableButton(value)
  }

  const renderTravellersArray = () => {
    const isGroup = groupType === 'group';

    if (isEmpty(travellers)) {
      return null;
    }

    return (
      <>
        {renderLeadTravellerDetails()}
        <FieldArray
          name="travellers"
          i18n={i18n}
          product={product}
          component={Travellers}
          travellers={travellers}
          selectedAdultNumber={isGroup ? selectedGroupAdultNumber : selectedAdultNumber}
          synchronousError={synchronousError}
          selectedChildrenNumber={isGroup ? selectedGroupChildrenNumber : selectedChildrenNumber}
          groupType={groupType}
          renderDefinition={renderDefinition}
          change={change}
          disableButtons={handleDisableButtons}
          isRenewal={false}
          {...props}
        />
      </>
    )
  }

  const canShowTravellers = groupType !== 'family' && groupType !== 'family_one_adult' && groupType !== 'group';
  const isCoupleSelected = groupType === 'couple';
  const isSingleSelected = groupType === 'individual';
  const hideRecalculate = (!showRecalculateButton && isSingleSelected);
  const shouldShowRecalculate = (isCoupleSelected && !hideRecalculate || isSingleSelected && !hideRecalculate || forceShowRecalculate && isSingleSelected);

  const renderGroup = () => {
    return (<>
      {!savedGroupSelection && (
        <div className={'family-select-container'}>
          <Row>
            <Col xs={12} className={'title'}>How many people in your group?</Col>
          </Row>
          <Row style={{ marginTop: '10px' }}>
            <Col xs={6}>Adults</Col>
            <Col xs={6}>{renderAdultGroupDropdown()}</Col>
          </Row>
          <Row style={{ padding: '10px 0 10px 0' }}>
            <Col xs={6}>
              Children
              <div style={{ fontSize: '1.5rem' }}>
                or dependants under 18
              </div>
            </Col>
            <Col xs={6}>{renderChildrenGroupDropdown()}</Col>
          </Row>
        </div>
      )}

      {!groupSelectionError && savedGroupSelection && (
        <div style={{ marginTop: '20px' }}>
          {renderTravellersArray()}
        </div>
      )}

      {groupSelectionError && (
        <ErrorDisplay error={groupSelectionError}/>
      )}

      <Row className={'button-group'}>
        <Col xs={6}>
          {savedGroupSelection && (
            <Button
              bsSize={'small'}
              type="button"
              block={true}
              onClick={handleGroupGoBack}
              disabled={!valid || disableButton}
              className={'admiral-white-btn'}>
              BACK
            </Button>
          )}
        </Col>
        <Col xs={6}>
          {!savedGroupSelection && (
            <Button
              bsSize={'small'}
              type="button"
              block={true}
              onClick={handleSaveGroupSelection}
              className={'admiral-primary-btn'}>
              CONTINUE
            </Button>
          )}
          {savedGroupSelection && !hideRecalculate && !hideRecalculateButton && (
            <>
              {renderRecalculateButton()}
            </>
          )}
        </Col>
      </Row>
    </>)
  }

  const renderFamilySelect = () => {
    return (
      <>
        {!savedFamilySelection && (
          <div className={'family-select-container'}>
            <Row>
              <Col xs={12} className={'title'}>How many people in your family?</Col>
            </Row>
            <Row style={{ marginTop: '10px' }}>
              <Col xs={6}>Adults</Col>
              <Col xs={6}>{renderAdultDropdown()}</Col>
            </Row>
            <Row style={{ padding: '10px 0 10px 0' }}>
              <Col xs={6}>
                Children
                <div style={{ fontSize: '1.5rem' }}>
                  or dependants under 25 in full-time education
                </div>
              </Col>
              <Col xs={6}>{renderChildrenDropdown()}</Col>
            </Row>
          </div>
        )}
        {savedFamilySelection && (
          <div style={{ marginTop: '20px' }}>
            {renderTravellersArray()}
          </div>
        )}

        <Row className={'button-group'}>
          <Col xs={6}>
            {savedFamilySelection && (
              <Button
                bsSize={'small'}
                type="button"
                block={true}
                onClick={handleGoBack}
                disabled={!valid || disableButton}
                className={'admiral-white-btn'}>
                BACK
              </Button>
            )}
          </Col>
          <Col xs={6}>
            {!savedFamilySelection && (
              <Button
                bsSize={'small'}
                type="button"
                block={true}
                onClick={handleSaveFamilySelection}
                className={'admiral-primary-btn'}>
                CONTINUE
              </Button>
            )}
            {savedFamilySelection && !hideRecalculate && !hideRecalculateButton && (
              <>
                {renderRecalculateButton()}
              </>
            )}
          </Col>
        </Row>
      </>
    )
  }

  const tripTypes = get(product, 'metadata.group_type_trip_annual');

  if (!tripTypes) {
    return null;
  }


  return (
    <>
      <div>
        {map(get(product, 'metadata.group_type_trip_annual'), (name, key) => {
          return renderGroupTypes(name, key);
        })}
        {showFamilySelect && renderFamilySelect()}
        {showGroupSelect && renderGroup()}
        {canShowTravellers && (
          <div style={{ marginTop: '20px' }}>
            {renderTravellersArray()}
          </div>
        )}
      </div>
      {shouldShowRecalculate && !hideRecalculateButton && (
        <>
          {renderRecalculateButton()}
        </>
      )}
    </>
  )
}

let selector;
// Hack part2 to reload the travellers - to get the current state from the form after re-render (part1 StartNewQuote)
export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
  }),
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
    (state: IStore) => {
      const travellers = selector(state, 'travellers');
      return {
        travellers,
      };
    },
  ),
])(GroupTypeSelection);
